import { IGetMonitoramentoChecklistFuncionarioDropDownUseCase } from "../../../presentation/useCases/read/get_monitoramento_checklist_funcionario_drop_down_use_case";
import { MonitoramentoChecklistFuncionario } from "../../models/monitoramento_checklist_funcionario";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetMonitoramentoChecklistFuncionarioDropDownUseCase
 */

export class GetMonitoramentoChecklistFuncionarioDropDownUseCase
  implements IGetMonitoramentoChecklistFuncionarioDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getMonitoramentoChecklistFuncionarioDropDown(
    idObra: number,
  ): Promise<MonitoramentoChecklistFuncionario[]> {
    return await this.repository.getMonitoramentoChecklistFuncionarioDropDown(idObra);
  }
}
